module.exports = __webpack_public_path__ + "img/epos-banner.cdd8cb28.jpg";